import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
// import axios from "axios";
import logo from "./assets/Nexus_logo@3x.png";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "./ApiUrl";
import Loader from "./loader";
import logoDark from "./assets/Nexus_logo@3x_Dark.png";
import { internalUsers } from "./constants/userTypes";
import { clearLocalStorage } from "./utils/clearLocalStorage";
import { TEXT } from "./dictionary";
import translations from "./translation.json";



const Login = ({ isDarkMode ,language , setLanguage }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("token"));

  // useLocation gives you access to the current URL location
  const location = useLocation();
  const passwordResetRequired = new URLSearchParams(location.search).get("password_reset_required") === "1";
  const parent_id = location.state?.parent_id || null;
  // Get the value of the 'reset_token' query parameter
  // const queryParams = new URLSearchParams(location.search);
  // const parent_id = queryParams.get('parent_id');

  const dashboardTypes = ["1", "manager", "representative", "animator"];
  
const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email(TEXT[language].invalidEmail)
    .required(TEXT[language].emailRequired),
  password: Yup.string()
    .required(TEXT[language].passwordRequired)
    .min(8, TEXT[language].passwordMin),
  // .matches(/[A-Z]/, "Password must contain at least one uppercase character"),
});

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setLoading(true);
      const res = await fetch(ApiUrl + "/api/user/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: values.email,
          password: values.password,
        }),
      });
      const data = await res.json();

      if (data.status === "success") {
        toast.success(TEXT[language].loginSuccess, {
          position: toast.POSITION.TOP_RIGHT,
        });

        setToken(data.token);
        localStorage.setItem("token", data.token);
        localStorage.setItem("userType", data.user.roles[0].name);
        localStorage.setItem("userData", JSON.stringify(data.user));
        localStorage.setItem("eventsFilterData", JSON.stringify([]));
        localStorage.setItem("eventsFilterPostData", JSON.stringify({}));
        localStorage.setItem("clientsFilterData", JSON.stringify([]));
        localStorage.setItem("clientsFilterPostData", JSON.stringify({}));
        localStorage.setItem("appointmentsFilterData", JSON.stringify([]));
        localStorage.setItem("appointmentsFilterPostData", JSON.stringify({}));
        localStorage.setItem("calendarSelectedDate", JSON.stringify(""));
      } else {
        setLoading(false);
        toast.error(data.code === "PASSWORD_RESET_REQUIRED"
          ? translations.usersPage.passwordReset.requiredMessage[language]
          : TEXT[language].authFailed);
      }
      // console.log(data);

      // if (data.token) {
      //   navigate('/event-portal');
      // }
    } catch (error) {
      setLoading(false);
      toast.error(TEXT[language].somethingWrong);
    }

    // setLoadng(true);
    // await axios
    //   .post(`${process.env.REACT_APP_BASEURL}auth/login`, values)
    //   .then((res) => {
    //     setLoadng(false);
    //     resetForm();
    //     localStorage.setItem("token", res.data.token);
    //     localStorage.setItem("user", JSON.stringify(res.data.data));
    //     if (res.data.data.role === "admin") {
    //       navigate("/all-products");
    //     } else {
    //       navigate("/");
    //     }
    //   })
    //   .catch((error) => {
    //     setLoadng(false);
    //     toast.error(error.response.data.message);
    //     console.error("Error updating user data:", error);
    //   });
  };
  useEffect(() => {
    const handleFetchUserData = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/loggeduser", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          if (token) {
            if (internalUsers.includes(data?.user?.roles[0]?.name)) {
              navigate("/event-portal", { replace: true });
            } else if (
              data.user?.roles[0]?.name === "Manager" ||
              data.user?.roles[0]?.name === "Employee"
            ) {
              if (parent_id) {
                // navigate("/client-form?parent_id=" + parent_id, {
                //   replace: true,
                // });
                navigate("/event-portal" + parent_id, {
                  replace: true,
                });
              } else {
                // navigate("/client-dashboard", { replace: true });
                navigate("/event-portal", { replace: true });
              }
            } else {
              toast.error(TEXT[language].invalidUserType);
              clearLocalStorage();
            }
            // const userData = handleFetchUserData();
            // if (userData.user_type === 'admin') {
          }
        } else {
          toast.error(TEXT[language].authFailed);
        }
        // return data;
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(TEXT[language].somethingWrong);
      }
    };
    token && handleFetchUserData();
  }, [token]);
  

const handleLanguageChange = (e) => {
  const value = e.target.value;
  setLanguage(value);
  localStorage.setItem("unauthorized_pages_language", value);
};

  return (
    <div style={{ position: "relative" }}>
      <div
        className=""
        style={{ position: "absolute", right: "30px", top: "20px" }}
      >
        <select
          value={language}
          onChange={handleLanguageChange}
          style={{
            // width: "150px",
            height: "38px",
            fontSize: "16px",
            fontWeight: "500",
            borderRadius: "6px",
            border: "1px solid #ced4da",
            backgroundColor: "#ffffff",
            color: "#495057",
            padding: "0px 6px",
            boxShadow: "0px 1px 2px rgba(0,0,0,0.08)",
            cursor: "pointer",
            width: "130px",
            height: "30px",
          }}
        >
          <option value="en">{TEXT[language].langEnglish}</option>
          <option value="fr">{TEXT[language].langFrench}</option>
        </select>
      </div>

      <div
        className="d-flex align-items-center dark-light"
        style={{ paddingTop: "50px" }}
      >
        <div
          className="form-wrapper appcountainer dark"
          style={{ width: "500px", minHeight: "650px" }}
        >
          <div className="mb-3"></div>
          <main className="form-signin mx-auto">
            {passwordResetRequired && (
              <div role="alert" className="alert alert-warning">
                {translations.usersPage.passwordReset.requiredMessage[language]}
              </div>
            )}
            <Formik
              initialValues={{
                email: "",
                password: "",
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <Form>
                <div className="d-flex justify-content-center">
                  <Link to="/">
                    <img
                      className="mb-4"
                      width="100px"
                      src={isDarkMode ? logoDark : logo}
                      alt=""
                    />
                  </Link>
                </div>

                <div className="form-floating">
                  <Field type="email" name="email" className="form-control" />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-danger error"
                  />
                  <label htmlFor="floatingInput ">{TEXT[language].email}</label>
                </div>
                <div className="form-floating mt-3">
                  <Field
                    type="password"
                    name="password"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-danger error"
                  />
                  <label htmlFor="floatingPassword">
                    {TEXT[language].password}
                  </label>
                </div>

                <button
                  className="btn-lg btn-primary w-100 admin-btn mt-3"
                  type="submit"
                  disabled={loading}
                >
                  {/* {loading ? "Signing in..." : "Sign in"} */}
                  {loading ? TEXT[language].signingIn : TEXT[language].signIn}
                </button>
              </Form>
            </Formik>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Login;
